import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../Components/Layout";
import styles from "./history.module.css";
import { getUserHistory } from "../../Services/APIrequests";

const Myhistory = () => {
  const [historyData, setHistoryData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getUserHistory();
        setHistoryData(response.data);
      } catch (error) {
        console.error("Error fetching history data:", error);
        setHistoryData([]);
      }
    };
    fetchData();
  }, []);

  const handleCINClick = (cin) => {
    navigate(`/kohere/Companydetails/${cin}`);
  };

  const filteredHistoryData = historyData.filter(
    (item) =>
      item.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.viewDate.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Layout Active={"My History"}>
      <div className={styles.history_container}>
        <div className={styles.sub_container}>
          <div className={styles.history_search_container}>
            <input
              type="text"
              placeholder="Search here..."
              className={styles.serch_input}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {filteredHistoryData.length > 0 ? (
            filteredHistoryData.map((item, index) => (
              <div className={styles.history_1} key={index}>
                <div className={styles.history_comapany_start}>
                  <h3>{item.companyName.charAt(0).toUpperCase()}</h3>
                </div>
                <div className={styles.history_ptext}>
                  <span
                    className={`${styles.text} ${styles.cin_link}`}
                    onClick={() => handleCINClick(item.CIN)}
                    style={{
                      cursor: "pointer",
                      color: "var(--PrimaryColor)",
                      fontWeight: "700",
                    }}
                  >
                    {item.companyName}
                  </span>
                  <span className={styles.text}>{item.viewTime}</span>
                </div>
                <div>
                  <h3 className={styles.history_header_text}>
                    {item.dayName} - {item.viewDate}
                  </h3>
                </div>
              </div>
            ))
          ) : (
            <p className={styles.text}>No history available.</p>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Myhistory;
